import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pulldown } from 'jbc-front/components/icons';
import { useSession } from '@/components/SessionProvider';
import { hasPermission } from '@/utils/permission';
import styles from './Settings.scss';

const Item = ({ title, text, to, disabled = false }) => {
  const [showHint, setShowHint] = useState(false);
  const renderChildren = () => (
    <>
      {showHint && <Hint onClick={() => setShowHint(false)}>近日リリース予定の機能です</Hint>}
      <dl className={styles.definition}>
        <dt className={styles.dt}>
          <span className={styles.icon}>
            <Pulldown size={13} transform="rotate(-90)" />
          </span>
          {title}
        </dt>
        <dd className={styles.text}>{text}</dd>
      </dl>
    </>
  );
  return (
    <li className={disabled ? styles.liDisabled : styles.li}>
      {disabled ? (
        <div
          className={styles.itemDisabled}
          onClickCapture={e => {
            e.stopPropagation();
            setShowHint(true);
          }}>
          {renderChildren()}
        </div>
      ) : (
        <Link to={to} className={styles.itemWrap}>
          {renderChildren()}
        </Link>
      )}
    </li>
  );
};

const Hint = ({ onClick, children }) => {
  useEffect(() => {
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, [onClick]);
  return (
    <div className={styles.hint}>
      <div className={styles.hintShape} />
      <div className={styles.hintMessage}>{children}</div>
    </div>
  );
};

export const Settings = () => {
  const { user } = useSession();

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">設定</h1>
      </div>
      <div className="l-wrap-l l-contents-wrap">
        <div className={styles.main}>
          {hasPermission(user, 'stress_check_access') && (
            <section className={styles.section}>
              <h3 className={styles.category}>ストレスチェック</h3>
              <ul className={styles.list}>
                <Item
                  to="/settings/survey_forms"
                  title="調査フォーム"
                  text="依頼する調査フォームの内容を確認できます"
                />
                <Item to="/settings/mails" title="メールカスタマイズ" text="依頼メールの内容をカスタマイズできます" />
                <Item
                  to="/settings/implementation_surveys"
                  title="実施履歴"
                  text="実施したストレスチェックの確認、削除ができます"
                />
              </ul>
            </section>
          )}
          {hasPermission(user, 'regular_health_checkup_access') && (
            <section className={styles.section}>
              <h3 className={styles.category}>定期健康診断</h3>
              <ul className={styles.list}>
                <Item
                  to="/settings/health_checkup_institution"
                  title="健康診断実施機関マスタ"
                  text="健康診断の実施機関のマスタの作成・編集・削除ができます"
                />
              </ul>
            </section>
          )}
          {hasPermission(user, 'user_manage_list_users') && (
            <section className={styles.section}>
              <h3 className={styles.category}>権限</h3>
              <ul className={styles.list}>
                <Item to="/settings/users" title="権限管理" text="権限の変更、新規管理者の追加ができます" />
              </ul>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};
